// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/contacts",
  Create: "/pyr/employees/{employeeId}/contacts",
  Update: "/pyr/employees/{employeeId}/contacts",
  Detail: "/pyr/employees/{employeeId}/contacts",
};
